<template>
  <v-card hover style="display: flex; flex-direction: column;">
    <v-card-title style="padding-bottom: 5px;">
      <i class="fad fa-film" style="margin-right: 10px;"></i>
      {{ $t("general.media") }}
    </v-card-title>
    
    <div v-if="!loaded" style="text-align: center; height: 150px; display: flex; align-items: center; justify-content: center;">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <div v-else-if="moviesCount === 0 && tvshowsCount === 0" style="text-align: center; height: 150px; display: flex; align-items: center; justify-content: center; padding: 20px;">
      <p style="color: grey;">{{ $t("fitness.no_data_here") }}</p>
    </div>
    <div v-else style="flex-grow: 1;">
      <v-card-text>
        <div style="font-size: 12px; color: grey; text-align: center; margin-bottom: 10px;">
          {{ $t("movies.month") }}: {{ monthName }} {{ targetYear }}
        </div>
        <v-layout row wrap style="margin: 0;">
          <v-flex xs6 style="text-align: center; padding: 10px; cursor: pointer;" @click.stop="$router.push('/movies?date=' + date)">
            <i class="fad fa-film fa-2x" style="color: var(--v-primary-base); margin-bottom: 10px;"></i>
            <div style="font-size: 16px; font-weight: bold;">{{ moviesCount }}</div>
            <div style="font-size: 12px; color: grey; line-height: 1.2;">{{ $t("movies.header") }}</div>
          </v-flex>
          <v-flex xs6 style="text-align: center; padding: 10px; cursor: pointer;" @click.stop="$router.push('/tvshows?date=' + date)">
            <i class="fad fa-tv fa-2x" style="color: var(--v-primary-base); margin-bottom: 10px;"></i>
            <div style="font-size: 16px; font-weight: bold;">{{ tvshowsCount }}</div>
            <div style="font-size: 12px; color: grey; line-height: 1.2;">{{ $t("tvshows.header") }}</div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import { storage } from "../../schmucklicloud";

export default {
  props: {
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      moviesCount: 0,
      tvshowsCount: 0,
      targetMonth: 1,
      targetYear: 2026
    };
  },
  computed: {
    monthName() {
      var months = [
        this.$t("general.month.january"),
        this.$t("general.month.february"),
        this.$t("general.month.march"),
        this.$t("general.month.april"),
        this.$t("general.month.may"),
        this.$t("general.month.june"),
        this.$t("general.month.july"),
        this.$t("general.month.august"),
        this.$t("general.month.september"),
        this.$t("general.month.october"),
        this.$t("general.month.november"),
        this.$t("general.month.december")
      ];
      return months[this.targetMonth - 1];
    }
  },
  watch: {
    date() {
      this.loadData();
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loaded = false;
      this.moviesCount = 0;
      this.tvshowsCount = 0;
      
      let parts = this.date.split('-');
      this.targetYear = parseInt(parts[0]);
      this.targetMonth = parseInt(parts[1]);
      
      // Fetch all for the year and filter locally for safety
      var moviesResponse = await storage.get("movies", [
        { column: "watched_year", operator: "==", value: this.targetYear }
      ]);
      
      if (moviesResponse.isOK && moviesResponse.data) {
        this.moviesCount = moviesResponse.data.filter(m => parseInt(m.data.watched_month) === this.targetMonth).length;
      }
      
      var tvshowsResponse = await storage.get("tvshows", [
        { column: "watched_year", operator: "==", value: this.targetYear }
      ]);
      
      if (tvshowsResponse.isOK && tvshowsResponse.data) {
        this.tvshowsCount = tvshowsResponse.data.filter(t => parseInt(t.data.watched_month) === this.targetMonth).length;
      }
      
      this.loaded = true;
    }
  }
};
</script>
